// src/lib/http.ts
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { UNAUTHORIZED } from '@/constants/status-code.contant'

class HttpClient {
  private axiosInstance: AxiosInstance

  constructor(baseURL: string) {
    this.axiosInstance = axios.create({
      baseURL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true, // Tự động gửi cookie với mỗi yêu cầu
    })
    this.initializeResponseInterceptor()
  }

  private initializeResponseInterceptor() {
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config
        if (error.response?.status === UNAUTHORIZED && !originalRequest._retry) {
          originalRequest._retry = true
          try {
            // Gọi API để làm mới token
            await axios.get('/api/auth/refresh', { withCredentials: true })
            return this.axiosInstance(originalRequest)
          } catch (error) {
            throw Error('Refresh token failed:' + error)
            await axios.get('/api/auth/sign-out')
            // Chuyển hướng đến trang đăng nhập
            window.location.href = '/'
          }
        }
        return Promise.reject(error)
      }
    )
  }

  // Các phương thức HTTP cơ bản

  public async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.handleRequest(() => this.axiosInstance.get<T>(url, config))
  }

  public async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    return this.handleRequest(() => this.axiosInstance.post<T>(url, data, config))
  }

  public async put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    return this.handleRequest(() => this.axiosInstance.put<T>(url, data, config))
  }

  public async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.handleRequest(() => this.axiosInstance.delete<T>(url, config))
  }

  // Xử lý lỗi tổng quát
  private async handleRequest<T>(request: () => Promise<AxiosResponse<T>>): Promise<T> {
    try {
      const response = await request()
      return response.data
    } catch (error) {
      throw Error('Request failed:' + error)
      throw error
    }
  }
}

// Khởi tạo HttpClient instance
const http = new HttpClient('/api')

export default http
